/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc
 */

export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const BooleanFieldValueDiscriminant = 'boolean';
export const BooleanFieldValueDiscriminantKey = '@type';
export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const DoubleFieldValueDiscriminant = 'double';
export const DoubleFieldValueDiscriminantKey = '@type';
export const FieldValueDiscriminantKey = '@type';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const FloatFieldValueDiscriminant = 'float';
export const FloatFieldValueDiscriminantKey = '@type';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const IntFieldValueDiscriminant = 'integer';
export const IntFieldValueDiscriminantKey = '@type';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const ListFieldValueDiscriminant = 'list';
export const ListFieldValueDiscriminantKey = '@type';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const LongFieldValueDiscriminant = 'long';
export const LongFieldValueDiscriminantKey = '@type';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const MapFieldValueDiscriminant = 'map';
export const MapFieldValueDiscriminantKey = '@type';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const NullFieldValueDiscriminant = 'null';
export const NullFieldValueDiscriminantKey = '@type';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const StringFieldValueDiscriminant = 'string';
export const StringFieldValueDiscriminantKey = '@type';
export const getListingDetailsV2Rpc = {
  serviceName: 'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc',
  rpcName: 'getListingDetailsV2',
  auth: 'app',
  fingerprint: 'XXty8CSBgCBFlkikHog9NUa-r6BPox_M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getListingDetailsV3Rpc = {
  serviceName: 'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc',
  rpcName: 'getListingDetailsV3',
  auth: 'app',
  fingerprint: 'fDfyt5YhKRajfkJwW1qLGka-r6BPox_M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const isStandardizedInstallRpc = {
  serviceName: 'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc',
  rpcName: 'isStandardizedInstall',
  auth: 'app',
  fingerprint: 'krkkLOPAQwLlbiVV77nC_ka-r6BPox_M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAppFeaturesBatchRpc = {
  serviceName: 'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc',
  rpcName: 'getAppFeaturesBatch',
  auth: 'app',
  fingerprint: 'UTn1J709F-j5Dpfy5czg3ka-r6BPox_M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getListingSupplementRpc = {
  serviceName: 'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc',
  rpcName: 'getListingSupplement',
  auth: 'app',
  fingerprint: 'PkRsGcD7s8SwWM4tij5JEEa-r6BPox_M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};